import React from 'react'
import { Box, CircularProgress  } from '@mui/material';

export default function Preloader() {
  return (
    <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "300px", }} >
        <CircularProgress />
    </Box>
  )
}
